<div class="carousel-cnt">
  <div class="flex row-a scroll-horiz">
    <div class="carousel-cell" style="margin: 2rem 1rem;" *ngFor="let test of testimonials">
      <app-card-testimonial [cardData]="test"></app-card-testimonial>
    </div>
  </div>
</div>